// Pure functions for the Gallery page's Behold feed — no DOM, no fetch.
// Ported from ~/Documents/KEP/website/src/components/InstagramFeed.tsx.

/** Behold's feed endpoint returns either a bare array or { posts: [...] }. */
export function parseFeedItems(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.posts)) return data.posts;
    return [];
}

/** Behold's reel permalinks (/reel/ or /reels/) resolve fine as /p/ on Instagram. */
export function normalizePermalink(permalink) {
    return permalink.replace(/\/reels?\//, '/p/');
}

function escapeHtml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/**
 * Builds the markup for one feed item: the whole element is a link out to
 * the Instagram permalink (no separate "read more" affordance, unlike the
 * Handlebars `card` partial used for Ghost posts elsewhere in this theme).
 */
export function buildCardHtml(item) {
    const permalink = escapeHtml(normalizePermalink(item.permalink));
    const imageSrc = escapeHtml(item.thumbnailUrl || item.mediaUrl);
    const altText = escapeHtml(item.caption ? item.caption.slice(0, 100) : 'Instagram post');
    const titleText = escapeHtml(item.caption ? item.caption.slice(0, 120) : 'Instagram post');

    const playIconHtml = item.mediaType === 'VIDEO'
        ? '<div class="card-play-icon" aria-hidden="true"><svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="rgba(255,255,255,0.85)" /><polygon points="17,14 35,24 17,34" fill="#000" /></svg></div>'
        : '';

    const bodyHtml = item.caption
        ? `<div class="card-body"><p class="card-desc card-desc--clamp">${escapeHtml(item.caption)}</p></div>`
        : '';

    return `<a href="${permalink}" target="_blank" rel="noopener noreferrer" class="card" title="${titleText}"><div class="card-image"><img src="${imageSrc}" alt="${altText}" loading="lazy" />${playIconHtml}</div>${bodyHtml}</a>`;
}
